var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view',{attrs:{"title":"購買流程","backable":true}},[_c('div',{staticClass:"p-5"},[_c('img',{attrs:{"src":_vm.imgs.procedure,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }